import { TempArquivo } from "./typings";
import { AxiosError } from "axios";
import { showErrorAxios } from "infra/helpers/alerta";
import { httpUploads } from "infra/http";
import { useMutation } from "react-query";

function useUploadAnexos(props?: { publico?: boolean }) {
  return useMutation<
    TempArquivo[],
    AxiosError<any>,
    {
      files: File[];
      onUploadProgress: (nome: string, progress: number) => any;
    },
    any
  >(
    ({
      files,
      onUploadProgress,
    }: {
      files: File[];
      onUploadProgress: (nome: string, progress: number) => any;
    }) => {
      return new Promise(async (resolve, reject) => {
        const anexos: TempArquivo[] = [];
        for (let i = 0; i < files.length; i++) {
          const formData = new FormData();
          formData.append("file", files[i]);
          try {
            const { data } = await httpUploads.post(
              `/v1/arquivos/upload-anexos`,
              formData,
              {
                onUploadProgress: (ev) => {
                  onUploadProgress(
                    files[i].name,
                    Math.round((ev.loaded * 100) / ev.total)
                  );
                },
              }
            );
            anexos.push(data);
          } catch (err) {
            showErrorAxios(err);
            reject(err);
          }
        }
        resolve(anexos);
      });
    },
    {
      retry: false,
      onError: (e) => {
        showErrorAxios(e);
      },
    }
  );
}

export default useUploadAnexos;
